module.exports = __webpack_public_path__ + "img/img_qiaomeng_pic.096c4829.png";